import type { MapSource } from '../map';
import { ZOMBIE_ARENAS } from './zombie-farm';

/**
 * Twin Hollows, a Zombie Nights map (ADR-0176): two fronts. The dead come from the west graveyard from night 1 and the
 * east one from night 3, each lane up and round a hollow (its pond, its willows) and in through a gap in the hedge ring
 * round the plaza; the north graveyard opens on night 12, its lane a dog-leg straight down at the door. How the gold is
 * split between the fronts is the map's question (a party's too: a front each). The south is the farm's own: its
 * orchard and meadows, where the apple crates grow. The arenas under it are every zombies map's (`ZOMBIE_ARENAS`).
 */
export const TWIN_HOLLOWS: MapSource = {
  id: 'twin-hollows',
  name: 'Back to Back',
  // Drawn in the village packs, as the battle royale's Village is (ADR-0206).
  style: 'village',
  rows: `
    ############################################################
    #............................:::...........................#
    #...........................:::::..........................#
    #...........................::Z::..........................#
    #...T.......................:::::......................T...#
    #............................:::...........................#
    #.......,.T..................::..................T.,.......#
    #.....,,,,,..................::..................,,,,,.....#
    #.....,,,,,..................::..................,,,,,.....#
    #.....,,,,,..................::..................,,,,,.....#
    #.....o.,....................::::::::..............,.o.....#
    #............................::::::::......................#
    #..................................::......................#
    #..................................::......................#
    #.......................o..........::......................#
    #..................................::......................#
    #...T........................::::::::..................T...#
    #............................::::::::......................#
    #............................::............................#
    #........:::::::::::.........::.........:::::::::::........#
    #........:::::::::::.........::.........:::::::::::........#
    #........::.......::########.::.########::.......::........#
    #........::.T.....::########.::.########::.....T.::........#
    #........::..~~~..::##.......::.......##::..~~~..::........#
    #........::..~~~..::##.......::.......##::..~~~..::........#
    #........::..~~~..::##.......::.......##::..~~~..::........#
    #........::.....T.::##.......::.......##::.T.....::........#
    #........::.......::##......b::b......##::.......::........#
    #.:::....::.......::.......======.......::.......::....:::.#
    #::::::::::.......::::::::::=BB==:::::::::.......::::::::::#
    #::Z:::::::.......::::::::::=BB==:::::::::.......:::::::Z::#
    #:::::.....................======.....................:::::#
    #.:::...............##......bb=b......##...............:::.#
    #...................##................##...................#
    #...................##................##...................#
    #...................##................##...................#
    #.............o.....##................##.....o.............#
    #...................####################...................#
    #...................####################...................#
    #..........................................................#
    #....T........................o.......................T....#
    #..........................................................#
    #..........,,,.................................,,,.........#
    #........,,,,,,,.............................,,,,,,,.......#
    #.......,,,,,,,,,.....T...T...T...T...T.....,,,,,,,,,......#
    #.......,,,,,,,,,...........................,,,,,,,,,......#
    #.......,,,,,,,,,...........................,,,,,,,,,......#
    #.......,,,,,,,,,...........................,,,,,,,,,......#
    #.......,,,,,,,,,.....T...T...T...T...T.....,,,,,,,,,......#
    #........,,,,,,,.............................,,,,,,,.......#
    #..........,,,................,................,,,.........#
    #...........................,,,,,..........................#
    #.......o..................,,,,,,,.................o.......#
    #..........................,,,,,,,.........................#
    #.................T........,,,,,,,.......T.................#
    #...........................,,,,,..........................#
    #.............................,............................#
    #..........................................................#
    #..........................................................#
    ############################################################
  `,
  arenas: ZOMBIE_ARENAS,
  // Its gates in reading order: the north (night 12), the west (night 1), the east (night 3).
  gateNights: [12, 1, 3],
  signs: [
    { cx: 17, cy: 27, gate: 1 },
    { cx: 42, cy: 27, gate: 2 },
    { cx: 31, cy: 13, gate: 0 },
  ],
  // Chomper (ADR-0180, ADR-0186): in from the edge, careening round the whole yard (all four quarters, out towards the
  // corners, through the plaza, crossing its own way) as if it had lost its mind, out again the way it came.
  chomper: {
    route: [
      [-3, 30],
      [11, 30],
      [11, 10],
      [51, 10],
      [51, 21],
      [42, 21],
      [42, 40],
      [50, 40],
      [50, 46],
      [36, 46],
      [36, 55],
      [20, 55],
      [20, 46],
      [28, 46],
      [28, 51],
      [7, 51],
      [7, 41],
      [16, 41],
      [16, 28],
      [24, 28],
      // A row up past the hedge's corner: the Greenhouse's roof is on row 28's edge (ADR-0206 amended).
      [24, 27],
      [33, 27],
      [33, 34],
      [27, 34],
      [27, 26],
      [24, 26],
      [24, 30],
      [-3, 30],
    ],
  },
};
